import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getAvatarInitials } from '@/lib/avatarUtils';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  username?: string | null;
  avatarUrl?: string | null;
  fallbackEmail?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  /** Apply signature photo filter to avatar image */
  usePhotoFilter?: boolean;
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-24 w-24',
};

const textSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-2xl',
};

export const UserAvatar = ({
  username,
  avatarUrl,
  fallbackEmail,
  size = 'md',
  className,
  usePhotoFilter = false,
}: UserAvatarProps) => {
  const initials = getAvatarInitials(username, fallbackEmail);

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      <AvatarImage 
        src={avatarUrl || undefined} 
        alt={username || 'User avatar'}
        className={cn(usePhotoFilter && avatarUrl && 'photo-signature')}
      />
      <AvatarFallback className={cn(
        'bg-primary/10 text-primary font-medium',
        textSizeClasses[size]
      )}>
        {initials}
      </AvatarFallback>
    </Avatar>
  );
};
